function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.1 4.4l1 1c.2.2.2.5 0 .7l-.7.7-1.7-1.7.7-.7c.2-.2.5-.2.7 0zM4.6 15.8v-1.7l7.7-7.6L14 8.2l-7.6 7.7zm8.5-10l1.7 1.7m-2.6.8l-4.8 4.9m5-6.8l1.3-1.3 1.7 1.7-1.3 1.3zm-7.5 7.7l1.5 1.5",
  fill: "none",
  strokeLinejoin: "round",
  strokeWidth: ".5",
  stroke: "currentColor"
}));